
import { network, contractAddress, GAS_LIMIT, ENVIROMENT, ChainID } from 'config';

export const environment = ENVIROMENT;
export const contractAddresses = contractAddress;
export const gasLimit = GAS_LIMIT;
export const chainID = ChainID;
export { network };